import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ImaginaeToken } from 'src/app/models/imaginae-token.model';
import { globals } from '../utils/globals';
import { InfoService } from './info.service';

@Injectable()
export class LocalStorageService {
  currentValue: any;
  constructor(
    public translate: TranslateService,
    public globals: globals,
    private infoService: InfoService
  ) {}

  /**
   *	Guarda una nueva preferencia.
   **/
  setItem(key: any, value: any) {
    if (this.infoService.isPlatformBrowser()) localStorage.setItem(key, value);
  }

  /**
   *	Devuelve una preferencia.
   **/
  getItem(key: any = null, defaultValue: any = null) {
    if (this.infoService.isPlatformBrowser()) return localStorage.getItem(key);
    else return null;
  }

  /**
   *	Guarda un conjunto de preferencias.
   **/
  setObject(key: any, value: any) {
    if (this.infoService.isPlatformBrowser())
      localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   *	Devuelve un conjunto de preferencias.
   **/
  getObject(key: any) {
    let obj: any = localStorage.getItem(key);
    if (this.infoService.isPlatformBrowser())
      return !obj ? null : JSON.parse(obj);
    else return null;
  }

  /**
   *	Elimina una preferencia.
   **/
  removeItem(key: any) {
    console.log(
      'removeItem this.infoService.isPlatformBrowser()=' +
        this.infoService.isPlatformBrowser()
    );
    if (this.infoService.isPlatformBrowser()) localStorage.removeItem(key);
  }

  clear() {
    this.currentValue = null;
    if (this.infoService.isPlatformBrowser()) localStorage.clear();
  }
  /*
  getCurrentUser(): User | null {
    if (this.infoService.isPlatformBrowser()) {
      let userjson = this.getObject(this.globals.constants.STORAGE_USER_INFO);
      let userData: User = new User();
      userData.createFromJson(userjson);
      return userData;
    } else {
      return null;
    }
  }

  setCurrentUser(user: User | null) {
    if (this.infoService.isPlatformBrowser()) {
      this.setObject(this.globals.constants.STORAGE_USER_INFO, user);
    }
  }*/

  getToken(): ImaginaeToken | null {
    if (this.infoService.isPlatformBrowser()) {
      let token: any = this.getObject(
        this.globals.constants.STORAGE_TOKEN_INFO
      );

      let tokenData: ImaginaeToken | null = null;
      if (token && token.accessToken) {
        tokenData = new ImaginaeToken();
        tokenData.setAccessToken(token.accessToken);
        tokenData.setRefreshToken(token.refreshToken);
        tokenData.setExpiresAt(token.expiresAt);
      }
      return tokenData;
    } else {
      return null;
    }
  }

  setToken(token: ImaginaeToken | null) {
    if (this.infoService.isPlatformBrowser()) {
      this.setObject(this.globals.constants.STORAGE_TOKEN_INFO, token);
    }
  }
}
